import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class DownloadFileService {
  constructor() {}
  downloadFile(blob: Blob, filename: string, type: string): void {
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${filename}-${moment().format('YYYYMMDDHHMMSS')}.${type.toLocaleLowerCase()}`;
    link.click();
  }
}
